module.exports = __webpack_public_path__ + "img/69.c13ea38b.jpg";